import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import { NOTIFICATION_STATES } from "@/modules/Notification/constants/NotificationConstants";
import { ORDER_STATES } from "@/modules/Orders/constants/OrderConstants";
import { SERVICE_STATES } from "@/modules/Services/constants/ServicesConstants";
import { TASK_STATES } from "@/modules/Tasks/constants/TaskConstants";
import { DATE_OPERATORS } from "@/shared/constants/GeneralConstants";

export const TYPE_DETAILS = {
  ORDER: "order",
  TASKS: "tasks",
  FORM: "form",
  SERVICE: {
    SECTION: "serviceSection",
    GROUP: "serviceGroup"
  }
};

export const EMITTED_EVENT = {
  SHOW_DETAILS: "showDetails",
  HIDE_DETAILS: "hideDetails",
  SHOW_NOTES: "showNotes",
  HIDE_NOTES: "hideNotes",
  SHOW_PREVIEW: "showPreview",
  HIDE_PREVIEW: "hidePreview",
  SHARE_DOCUMENT: "shareDocument",
  EDIT_DOCUMENT: "editDocument",
  DELETE_DOCUMENT: "deleteDocument",
  NEW_EVENT: "newEvent"
};

export const EVENT_MESSAGES = {
  REQUEST_FAILED: "Ha ocurrido un error, intente más tarde.",
  RESPONSE_EVENTS_UNDEFINED: "No se han encontrado eventos."
};

export const LABEL = {
  SWITCH: "Ver Tarjeta",
  CHANNEL: "Canal: ",
  ACTIONS_GENERATED: "Generadas",
  ACTIONS_RECEIVED: "Recibidas",
  PLACEHOLDER_USER: "Nombre de usuario",
  LABEL_USER: "Usuario"
};

export const ICONS_TYPES = {
  ["notificación"]: "mdi-bell",
  ["orden"]: "mdi-receipt",
  ["servicio"]: "mdi-shape-plus",
  ["tarea"]: "mdi-checkbox-multiple-marked-outline",
  ["usuario"]: "mdi-account-check",
  ["documento"]: "mdi-file-multiple",
  ["cita"]: "mdi-calendar-check",
  ["plantilla formulario"]: "mdi-form-textbox",
  ["listas"]: "mdi-format-list-checkbox",
  ["grupos información"]: "mdi-newspaper-variant-multiple",
  ["plantilla usuario"]: "mdi-clipboard-account",
  ["roles"]: "mdi-account-hard-hat",
  ["cups"]: "mdi-currency-usd",
  ["plantilla sesión"]: "mdi-file-tree-outline",
  ["plantilla servicio"]: "mdi-room-service-outline",
  ["disponibilidad"]: "mdi-timer-outline",
  ["sede"]: "mdi-domain",
  ["dependencia"]: "mdi-graphql",
  ["espacios"]: "mdi-crop-square",
  ["regla"]: "mdi-sitemap",
  ["plantilla pdf"]: "mdi-file",
  ["multimedia"]: "mdi-file-multiple",
  ["plan de accion"]: "mdi-file",
  ["formulario"]: "mdi-list-box"
};

export const ICONS_COLORS = {
  ["notificación"]: "#9CC4D5",
  ["orden"]: "#F39A9D",
  ["servicio"]: "#69D1C5",
  ["tarea"]: "#F7A072",
  ["usuario"]: "#008080",
  ["documento"]: "#938B9F",
  ["cita"]: "#B980B9",
  ["plantilla formulario"]: "#EF9A9A",
  ["listas"]: "#F48FB1",
  ["grupos información"]: "#CE93D8",
  ["plantilla usuario"]: "#90CAF9",
  ["roles"]: "#9FA8DA",
  ["cups"]: "#B39DDB",
  ["plantilla sesión"]: "#81D4FA",
  ["plantilla servicio"]: "#80DEEA",
  ["disponibilidad"]: "#E6EE9C",
  ["sede"]: "#FFCC80",
  ["dependencia"]: "#FFAB91",
  ["espacios"]: "#B0BEC5",
  ["regla"]: "#EFB663",
  ["plantilla pdf"]: "#BB5659",
  ["multimedia"]: "#938B9F",
  ["plan de accion"]: "#BB5659",
  ["formulario"]: "#07B38F"
};

export const ICONS_CHANNEL = {
  ["whatsapp"]: "mdi-whatsapp",
  ["push"]: " mdi-message-text-outline"
};

export const MINUTE_IN_MS = 60000;
export const DAY_IN_MS = 86400000;
export const OFFSET_DATE = 7;
export const LAST_X_DAYS = new Date(Date.now() - DAY_IN_MS * OFFSET_DATE);

export const INITIAL_FILTER_CHIP = {
  filterKey: "dateCreated",
  name: "Fecha de creación",
  operator: ">=",
  value: LAST_X_DAYS.toISOString().substr(0, 10),
  displayValue: LAST_X_DAYS.toISOString().substr(0, 10),
  parentFilter: "all",
  type: "picker"
};

const OPERATORS_FILTERS = [{ name: "=", key: "==", type: "operators" }];

const ORDER_STATES_ARRAY = [
  { key: ORDER_STATES.BILLED, name: ORDER_STATES.BILLED },
  { key: ORDER_STATES.NEW, name: ORDER_STATES.NEW },
  { key: ORDER_STATES.AUTHORIZED, name: ORDER_STATES.AUTHORIZED },
  { key: ORDER_STATES.COMPLETED, name: ORDER_STATES.COMPLETED },
  { key: ORDER_STATES.CANCELED, name: ORDER_STATES.CANCELED }
];

const TASK_STATES_ARRAY = [
  { key: TASK_STATES.PENDING, name: TASK_STATES.PENDING },
  { key: TASK_STATES.COMPLETED, name: TASK_STATES.COMPLETED }
];

const NOTIFICATION_STATES_ARRAY = [
  { key: NOTIFICATION_STATES.SENT, name: NOTIFICATION_STATES.SENT }
];

const SERVICES_STATES_ARRAY = [
  { key: SERVICE_STATES.ASSIGNED, name: SERVICE_STATES.ASSIGNED },
  { key: SERVICE_STATES.CANCELED, name: SERVICE_STATES.CANCELED },
  { key: SERVICE_STATES.COMPLETED, name: SERVICE_STATES.COMPLETED },
  { key: SERVICE_STATES.PROGRESS, name: SERVICE_STATES.PROGRESS },
  { key: SERVICE_STATES.NOT_ASSIGNED, name: SERVICE_STATES.NOT_ASSIGNED }
];

const NAME_SECONDARY_FILTER = {
  name: "Nombre",
  placeholder: "Nombre de Evento",
  key: "name",
  avatar: "mdi-calendar-month",
  type: "service",
  disabled: true,
  operators: DATE_OPERATORS,
  display: "unique"
};

const DATE_CREATED_SECONDARY_FILTER = {
  name: "Fecha de creación",
  key: "dateCreated",
  avatar: "mdi-calendar-month",
  type: "service",
  disabled: true,
  operators: DATE_OPERATORS,
  display: "picker"
};

const STATE_SECONDARY_FILTER = {
  name: "Estado",
  placeholder: "Estado de Evento",
  key: "state",
  avatar: "mdi-state-machine",
  type: "service",
  disabled: false,
  operators: OPERATORS_FILTERS,
  display: "list"
};

export const FILTERS_LIST: Filter[] = [
  {
    mainFilterKey: "all",
    mainFilterName: "Todos",
    initial: true,
    avatar: "mdi-animation",
    secondaryFilters: [NAME_SECONDARY_FILTER, DATE_CREATED_SECONDARY_FILTER]
  },
  {
    mainFilterKey: "orden",
    mainFilterName: "Orden",
    avatar: "mdi-receipt",
    secondaryFilters: [
      NAME_SECONDARY_FILTER,
      DATE_CREATED_SECONDARY_FILTER,
      { ...STATE_SECONDARY_FILTER, options: ORDER_STATES_ARRAY }
    ]
  },
  {
    mainFilterKey: "tarea",
    mainFilterName: "Tarea",
    avatar: "mdi-checkbox-multiple-marked-outline",
    secondaryFilters: [
      NAME_SECONDARY_FILTER,
      DATE_CREATED_SECONDARY_FILTER,

      { ...STATE_SECONDARY_FILTER, options: TASK_STATES_ARRAY }
    ]
  },
  {
    mainFilterKey: "notificación",
    mainFilterName: "Notificación",
    avatar: "mdi-bell",
    secondaryFilters: [
      NAME_SECONDARY_FILTER,
      DATE_CREATED_SECONDARY_FILTER,

      { ...STATE_SECONDARY_FILTER, options: NOTIFICATION_STATES_ARRAY }
    ]
  },
  {
    mainFilterKey: "servicio",
    mainFilterName: "Servicios",
    avatar: "mdi-shape-plus",
    secondaryFilters: [
      NAME_SECONDARY_FILTER,
      DATE_CREATED_SECONDARY_FILTER,

      { ...STATE_SECONDARY_FILTER, options: SERVICES_STATES_ARRAY }
    ]
  },
  {
    mainFilterKey: "documento",
    mainFilterName: "Documentos",
    avatar: "mdi-file-multiple",
    secondaryFilters: [NAME_SECONDARY_FILTER, DATE_CREATED_SECONDARY_FILTER]
  },
  {
    mainFilterKey: "usuario",
    mainFilterName: "Usuarios",
    avatar: "mdi-account-check",
    secondaryFilters: [NAME_SECONDARY_FILTER, DATE_CREATED_SECONDARY_FILTER]
  },
  {
    mainFilterKey: "cita",
    mainFilterName: "Citas médicas",
    avatar: "mdi-calendar-check",
    secondaryFilters: [NAME_SECONDARY_FILTER, DATE_CREATED_SECONDARY_FILTER]
  },
  {
    mainFilterKey: "regla",
    mainFilterName: "Reglas",
    avatar: "mdi-sitemap",
    secondaryFilters: [NAME_SECONDARY_FILTER, DATE_CREATED_SECONDARY_FILTER]
  },
  {
    mainFilterKey: "plantilla sesión",
    mainFilterName: "Sesiones",
    avatar: "mdi-text-box-multiple",
    secondaryFilters: [NAME_SECONDARY_FILTER, DATE_CREATED_SECONDARY_FILTER]
  },
  {
    mainFilterKey: "multimedia",
    mainFilterName: "Multimedia",
    avatar: "mdi-file-multiple",
    secondaryFilters: [NAME_SECONDARY_FILTER, DATE_CREATED_SECONDARY_FILTER]
  },
  {
    mainFilterKey: "plantilla pdf",
    mainFilterName: "Plantillas Pdf",
    avatar: "mdi-file",
    secondaryFilters: [NAME_SECONDARY_FILTER, DATE_CREATED_SECONDARY_FILTER]
  },
  {
    mainFilterKey: "formulario",
    mainFilterName: "Formulario",
    avatar: "mdi-list-box",
    secondaryFilters: [NAME_SECONDARY_FILTER, DATE_CREATED_SECONDARY_FILTER]
  }
];

export const MAIN_FILTER = {
  DOCUMENT: "documento",
  NOTIFICATION: "notificacion",
  SERVICE: "servicio",
  FORM: "formulario"
};

export const EVENT = {
  EMPTY_STATE: {
    HEADER: "No hay información para mostrar",
    PARAGRAPH: "Realiza una búsqueda para encontrar nueva información"
  },
  FIELDS: {
    TITLE: "Título",
    DESCRIPTION: "Descripción",
    STATE: "Estado",
    DETAILS: "Detalles",
    CREATED: "Creado",
    UPDATED: "Modificado",
    RULE: "Regla",
    USER_DATA: {
      NAME: "Nombre",
      DOCUMENT: "Documento"
    },
    SERVICE_NAME: "Servicio"
  },
  BTN_HINT: {
    SHARE: "Compartir",
    EDIT: "Editar categoria y subcategoria",
    PREVIEW: "Visualizar",
    NOTE: "Mostrar notas",
    SHOW_DETAILS: "Mostrar detalles",
    HIDE_DETAILS: "Ocultar detalles",
    MULTIPLE_RECIPIENTS: "Otros destinatarios",
    DOWNLOAD: "Descargar"
  }
};

export const EVENTS_ACCESS = {
  GET: "consultar eventos en línea de tiempo",
  POST_NOTES: "crear notas",
  PUT: "modificar eventos en línea de tiempo",
  DELETE: "eliminar eventos en línea de tiempo"
};
